@if (open()) {
  <div class="ui-modal-overlay" (click)="close()">
    <section
      class="ui-modal"
      [class.ui-modal--allow-overflow]="allowOverflow()"
      [attr.aria-label]="title() | uiLabelTranslate"
      [style.--ui-modal-max-width]="width() || maxWidth()"
      data-dropdown-boundary
      (click)="$event.stopPropagation()"
    >
      <header class="ui-modal__header">
        <div class="ui-modal__heading">
          <h3>{{ title() | uiLabelTranslate }}</h3>
          @if (description()) {
            <p>{{ description() | uiLabelTranslate }}</p>
          }
        </div>

        @if (showClose()) {
          <ui-button variant="ghost" icon="close" [ariaLabel]="'Close drawer' | uiLabelTranslate" (click)="close()">
            {{ 'Close' | uiLabelTranslate }}
          </ui-button>
        }
      </header>

      <div class="ui-modal__content" [class.ui-modal__content--allow-overflow]="allowOverflow()">
        <ng-content select="[modalBody]" />
        <ng-content />
      </div>

      <footer class="ui-modal__footer">
        <ng-content select="[modalFooter]" />
      </footer>
    </section>
  </div>
}
